import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { LayoutCommonVersionModule } from '../layout/layout-common-version.module';
import { GuardsModule } from '../guards/module';

import { PublicComponent } from './index.component';

import { StatsigService } from '@services/statsig.service';
import { Analytics } from '@services/analytics';

import { getRegisterLocalePromise } from '../lib/i18n';
import { gmapsLoadPromise } from '@app/lib/google-maps';

const COMPONENTS = [
  PublicComponent,
];

@NgModule({
  declarations: COMPONENTS,
  exports: COMPONENTS,
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    LayoutCommonVersionModule,
    GuardsModule,
    RouterModule.forRoot([
      {
        path: '',
        redirectTo: 'dispatch',
        pathMatch: 'full',
      },
      {
        path: 'dispatch',
        loadChildren: () => import('./dispatch-tracking/module').then(m => m.DispatchTrackingModule),
      },
      {
        path: 'share/:type/:uuid',
        loadChildren: () => import('./live-share-view/module').then(m => m.LiveSharingPublicModule),
      },
      {
        path: 'geotab-auth-fail',
        loadChildren: () => import('./geotab-auth-fail/module').then(m => m.GeotabAuthFailModule),
      },
      {
        path: 'transaction-review',
        loadChildren: () => import('./transaction-review/module').then(m => m.TransactionReviewModule),
      },
      {
        path: 'fleet-card-terms-of-service',
        loadChildren: () => import('./fleet-card-terms-of-service/module').then(m => m.FleetCardTermsOfServiceModule),
      },
      {
        path: 'motive-card-fee-schedule',
        loadChildren: () => import('./fleet-card-fee-schedule/module').then(m => m.FleetCardFeeScheduleModule),
      },
      {
        path: 'verify-card-application',
        loadChildren: () => import('./verify-card-application/module').then(m => m.VerifyCardApplicationModule),
      },
      {
        path: 'fleet-card-get-personalized-analysis',
        loadChildren: () => import('./fleet-card-get-personalized-analysis/module').then(m => m.FleetCardGetPersonalizedAnalysisModule),
      },
      {
        path: 'safety-recap-video',
        loadChildren: () => import('./safety-recap-video/module').then(m => m.SafetyRecapVideoModule),
      },
    ], { useHash: true }),
  ],
  bootstrap: [PublicComponent],
  providers: [
    Analytics,
    {
      provide: APP_INITIALIZER,
      useFactory: (statsigService: StatsigService) =>
        () => Promise.all([statsigService.waitUntilReady(), getRegisterLocalePromise(), gmapsLoadPromise]),
      deps: [StatsigService],
      multi: true,
    },
  ],
})
export class PublicModule { }
